import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "services/api";

import { __ } from "services/Translator";
import Slider from "react-slick";

const Banner = (props) => {
  const pageName = props.pageName;

  // LandingBanner

  const bannerSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    customPaging: function (i) {
      return (
        <a className={props.landingType}>
          <div className="round">
            <i class="fas fa-circle"></i>
          </div>
          <div className="line"></div>
        </a>
      );
    },
    dotsClass: "slick-dots banner_right",
  };

  const bannerRef = useRef();

  return (
    <>
      <section className="games_banner container-xxl">
        <div className="promotions_nav">
          <Link to="/welcome-promotions" className="item">
            <span
              className={
                (props.selectedMenu === "welcome-promotions"
                  ? "active show "
                  : "active ") + props.landingType
              }
            ></span>
            {__("Welcome Promotions")}
          </Link>
          <Link to="/slots-promotions" className="item">
            <span
              className={
                (props.selectedMenu === "slots-promotions"
                  ? "active show "
                  : "active ") + props.landingType
              }
            ></span>
            {__("Slots Promotions")}
          </Link>
          <Link to="/sportsbook-promorions" className="item">
            <span
              className={
                (props.selectedMenu === "sportsbook-promorions"
                  ? "active show "
                  : "active ") + props.landingType
              }
            ></span>
            {__("Sportsbook Promotions")}
          </Link>
          <Link to="/poker-promotions" className="item">
            <span
              className={
                (props.selectedMenu === "poker-promotions"
                  ? "active show "
                  : "active ") + props.landingType
              }
            ></span>
            {__("Poker Promotions")}
          </Link>
        </div>
        <Slider ref={bannerRef} {...bannerSettings}>
          <div className="slick_item">
            {/*  align-self-center */}
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="banner_heading">{__("20 Free Spins")}</div>
                <div className="banner_heading">{__("No Deposit.")}</div>
                <div className={"banner_title_italic " + props.landingType}>
                  {__("ON ANY SLOT GAME.")}
                </div>

                <div className="paragraph margin_top_30">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection"
                  )}
                </div>
                <div className="paragraph">
                  {__(
                    "of awesome, thrilling games. You decide which game you want to play the free spins on."
                  )}
                </div>

                <div className="banner_count white_border margin_top_30">
                  {props.totals && (
                    <>
                      <div className="count_area">
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalPlayers}+
                          </div>
                          <div className="paragraph">{__("Players Online")}</div>
                        </div>
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalGames}+
                          </div>
                          <div className="paragraph">{__("Games")}</div>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="custom_btn">
                    {props.isAuthenticated ? (
                      <Link
                        to="/games/slots"
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Play Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Sign Up Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="banner_img">
                  {pageName === "promotions" &&
                    (props.isMobileDevice ? (
                      <img
                        alt="game image"
                        src={
                          require("assets/images/banners/roulette-ii-mobile.png")
                            .default
                        }
                      />
                    ) : (
                      <img
                        alt="game image"
                        src="https://chimpbytes.imgix.net/promotions-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                      />
                    ))}
                  {pageName === "games" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/promotions-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                  {pageName === "vip" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/vip-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                </div>
              </div>
            </div>

            {pageName !== "games" && !props.isMobileDeviceByViewPort && (
              <div className="banner_features_list margin_bottom_30">
                <div className="single_item">{__("01. Best Quality")}</div>
                <div className="single_item">{__("02. Secure Payment")}</div>
                <div className="single_item">{__("03. Fast Pay - Outs")}</div>
                <div className="single_item">{__("04. Return Guarantee")}</div>
                <div className="single_item">{__("03. Support Customer")}</div>
              </div>
            )}
          </div>
          <div className="slick_item">
            {/*  align-self-center */}
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="banner_heading padding_top_15">
                  {__("20 Free Spins")}
                </div>
                <div className="banner_heading">{__("No Deposit.")}</div>
                <div className={"banner_title_italic " + props.landingType}>
                  {__("ON ANY SLOT GAME.")}
                </div>

                <div className="paragraph margin_top_30">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection"
                  )}
                </div>
                <div className="paragraph">
                  {__(
                    "of awesome, thrilling games. You decide which game you want to play the free spins on."
                  )}
                </div>

                <div className="banner_count white_border margin_top_30">
                  {props.totals && (
                    <>
                      <div className="count_area">
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalPlayers}+
                          </div>
                          <div className="paragraph">{__("Players Online")}</div>
                        </div>
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalGames}+
                          </div>
                          <div className="paragraph">{__("Games")}</div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="custom_btn">
                    {props.isAuthenticated ? (
                      <Link
                        to="/games/slots"
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Play Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Sign Up Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="banner_img">
                  {pageName === "promotions" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/promotions-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                  {pageName === "games" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/promotions-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                  {pageName === "vip" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/vip-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                </div>
              </div>
            </div>

            {pageName !== "games" && !props.isMobileDeviceByViewPort && (
              <div className="banner_features_list margin_bottom_30">
                <div className="single_item">{__("01. Best Quality")}</div>
                <div className="single_item">{__("02. Secure Payment")}</div>
                <div className="single_item">{__("03. Fast Pay - Outs")}</div>
                <div className="single_item">{__("04. Return Guarantee")}</div>
                <div className="single_item">{__("03. Support Customer")}</div>
              </div>
            )}
          </div>
          <div className="slick_item">
            {/*  align-self-center */}
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="banner_heading padding_top_15">
                  {__("20 Free Spins")}
                </div>
                <div className="banner_heading">{__("No Deposit.")}</div>
                <div className={"banner_title_italic " + props.landingType}>
                  {__("ON ANY SLOT GAME.")}
                </div>

                <div className="paragraph margin_top_30">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection"
                  )}
                </div>
                <div className="paragraph">
                  {__(
                    "of awesome, thrilling games. You decide which game you want to play the free spins on."
                  )}
                </div>

                <div className="banner_count white_border margin_top_30">
                  {props.totals && (
                    <>
                      <div className="count_area">
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalPlayers}+
                          </div>
                          <div className="paragraph">{__("Players Online")}</div>
                        </div>
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalGames}+
                          </div>
                          <div className="paragraph">{__("Games")}</div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="custom_btn">
                    {props.isAuthenticated ? (
                      <Link
                        to="/games/slots"
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Play Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Sign Up Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="banner_img">
                  {pageName === "promotions" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/promotions-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                  {pageName === "games" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/promotions-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                  {pageName === "vip" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/vip-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                </div>
              </div>
            </div>

            {pageName !== "games" && !props.isMobileDeviceByViewPort && (
              <div className="banner_features_list margin_bottom_30">
                <div className="single_item">{__("01. Best Quality")}</div>
                <div className="single_item">{__("02. Secure Payment")}</div>
                <div className="single_item">{__("03. Fast Pay - Outs")}</div>
                <div className="single_item">{__("04. Return Guarantee")}</div>
                <div className="single_item">{__("03. Support Customer")}</div>
              </div>
            )}
          </div>
          <div className="slick_item">
            {/*  align-self-center */}
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="banner_heading padding_top_15">
                  {__("20 Free Spins")}
                </div>
                <div className="banner_heading">{__("No Deposit.")}</div>
                <div className={"banner_title_italic " + props.landingType}>
                  {__("ON ANY SLOT GAME.")}
                </div>

                <div className="paragraph margin_top_30">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection"
                  )}
                </div>
                <div className="paragraph">
                  {__(
                    "of awesome, thrilling games. You decide which game you want to play the free spins on."
                  )}
                </div>

                <div className="banner_count white_border margin_top_30">
                  {props.totals && (
                    <>
                      <div className="count_area">
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalPlayers}+
                          </div>
                          <div className="paragraph">{__("Players Online")}</div>
                        </div>
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalGames}+
                          </div>
                          <div className="paragraph">{__("Games")}</div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="custom_btn">
                    {props.isAuthenticated ? (
                      <Link
                        to="/games/slots"
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Play Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Sign Up Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="banner_img">
                  {pageName === "promotions" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/promotions-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                  {pageName === "games" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/promotions-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                  {pageName === "vip" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/vip-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                </div>
              </div>
            </div>

            {pageName !== "games" && !props.isMobileDeviceByViewPort && (
              <div className="banner_features_list margin_bottom_30">
                <div className="single_item">{__("01. Best Quality")}</div>
                <div className="single_item">{__("02. Secure Payment")}</div>
                <div className="single_item">{__("03. Fast Pay - Outs")}</div>
                <div className="single_item">{__("04. Return Guarantee")}</div>
                <div className="single_item">{__("03. Support Customer")}</div>
              </div>
            )}
          </div>
          <div className="slick_item">
            {/*  align-self-center */}
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="banner_heading padding_top_15">
                  {__("20 Free Spins")}
                </div>
                <div className="banner_heading">{__("No Deposit.")}</div>
                <div className={"banner_title_italic " + props.landingType}>
                  {__("ON ANY SLOT GAME.")}
                </div>

                <div className="paragraph margin_top_30">
                  {__(
                    "Register and start playing right away with 20 Free Spins on a selection"
                  )}
                </div>
                <div className="paragraph">
                  {__(
                    "of awesome, thrilling games. You decide which game you want to play the free spins on."
                  )}
                </div>

                <div className="banner_count white_border margin_top_30">
                  {props.totals && (
                    <>
                      <div className="count_area">
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalPlayers}+
                          </div>
                          <div className="paragraph">{__("Players Online")}</div>
                        </div>
                        <div className="single_count">
                          <div className="number">
                            {props.totals.totalGames}+
                          </div>
                          <div className="paragraph">{__("Games")}</div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="custom_btn">
                    {props.isAuthenticated ? (
                      <Link
                        to="/games/slots"
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Play Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    ) : (
                      <Link
                        onClick={() => {
                          props.setModalSignUpPropsData(true);
                        }}
                        className={"angle_btn " + props.landingType}
                      >
                        {__("Sign Up Now")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="red"
                          class="bi bi-arrow-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                          />
                        </svg>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="banner_img">
                  {pageName === "promotions" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/promotions-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                  {pageName === "games" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/promotions-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                  {pageName === "vip" && (
                    <img
                      alt="game image"
                      src="https://chimpbytes.imgix.net/vip-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                    />
                  )}
                </div>
              </div>
            </div>

            {pageName !== "games" && !props.isMobileDeviceByViewPort && (
              <div className="banner_features_list margin_bottom_30">
                <div className="single_item">{__("01. Best Quality")}</div>
                <div className="single_item">{__("02. Secure Payment")}</div>
                <div className="single_item">{__("03. Fast Pay - Outs")}</div>
                <div className="single_item">{__("04. Return Guarantee")}</div>
                <div className="single_item">{__("03. Support Customer")}</div>
              </div>
            )}
          </div>
        </Slider>
      </section>
    </>
  );
};

export default Banner;
